document.addEventListener("DOMContentLoaded", function () {

  // Only run on mobile view
  if (window.innerWidth > 991) return;

  const headers = document.querySelectorAll(".more-info-tabs__nav-link.mobile");
  const panels = document.querySelectorAll(".tab-pane");

  if (!headers.length || !panels.length) return;

  // Default: Open first tab only
  headers.forEach(h => h.classList.remove("is-open"));
  panels.forEach(p => p.style.display = "none");

  headers[0].classList.add("is-open");
  panels[0].style.display = "block";

  headers.forEach(header => {
    header.addEventListener("click", function () {
      const targetId = this.getAttribute("data-id");
      const targetPanel = document.getElementById(targetId);
      const isOpen = this.classList.contains("is-open");

      // Close all first
      headers.forEach(h => h.classList.remove("is-open"));
      panels.forEach(p => p.style.display = "none");

      // Toggle clicked
      if (!isOpen) {
        this.classList.add("is-open");
        targetPanel.style.display = "block";
      }
    });
  });
});
